/* eslint-disable */
export default {
  init() {
    // JavaScript to be fired on the home page
    $(document).ready(function(){

      function slider(){
        $('.program__body__day__wrapper').slick({
          mobileFirst: true,
          slidesToShow: 2.1,
          slidesToScroll: 2,
          responsive: [
            {
              breakpoint: 992,
              settings: "unslick"
            }
          ]
        });
      }

      slider();

      $(window).resize(function(){
        slider();
      })

      $(window).scroll(function(){
        var section = $('.banner-home').height();
        var scrollTop = $(window).scrollTop();
        var parallax =  scrollTop * 0.3;
        var parallax2 = scrollTop * 0.1;
        if($(window).scrollTop() < section / 1.3){
          $('.banner-home__bg__left').css('transform', 'translateY('+parallax+'px)');
          $('.banner-home__bg__right').css('transform', 'translateY('+parallax2+'px)');
        }
      })



    })
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
/* eslint-enable */


// WEBPACK FOOTER //
// ./scripts/routes/home.js